import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import PageLevelRiverseTimer from "../../../Components/PageLevelRiverseTimer";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDate, validateRequired } from "../../../common/Validations";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import moment from "moment";
import ShowHorizontalStatus from "../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import Loader from "../../../Components/Loader";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import { getRfqQuotation } from "../../../redux/feature/supplier_app/sourcingSlice";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import { MultiselectField } from "../../../Components/formElements/MultiselectField";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import SupplierConstants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

const PublicTenderDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let tenderNr = useSelector((state) => state?.purchasing?.tender?.tenderNr); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.workflow); // config Details from Store
  let sourcingConfig = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [getTechnicalUserList, setTechnicalUserList] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const navigateToLogin = () => {
    navigate(SupplierConstants.PUBLIC_TENDOR_LIST);
  };

  const modalDataTeach = {
    title: "Tech Open",
    successMsg: "",
  };
  const modalDataComm = {
    title: "Commerial Open",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalDataTeach);
  const [formInputs, setFormInputs] = useState({
    tenderVersion: "V0",
    tenderContact: "",
    tenderDescription: "",
    tenderType: "",
    tenderTypeCategory: "",
    tenderValue: "",
    productType: "",
    tenderHeaderStatus: "Tender Created",
    tenderbidType: "",
    tenderEvalType: "",
    tenderCurrency: "",
    tndFocalTechPid: "",
    technicalApprovalType: "",
    plant: "",
    companyAddress: "", //i did'nt get in json
    rfxVersion: "V0",
    createdOn: "", //i did'nt get in json
    deliveryAddressCodeDesc: "",
    rfxTitle: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    formCOMM: [],
    formTECH: [],
  });

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroupDescription || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Material Category ",
      selector: (row) => row.venderMaterialSubCategory || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "UOM ",
      selector: (row) => row.unit || "--",
      width: "120px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "150px",
    },
    {
      name: "Delivery Date",
      selector: (row) => formatDate(row.deliveryDate) || "--",
      width: "150px",
    },
  ];
  const loadInitialPageData = async () => {
    if (tenderNr) {
      let obj = {
        queryName: "TenderDocumentDetail",
        documentNumber: tenderNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQueryV1(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item.data[0]);
          setData(item?.data[0]?.items);

          updateTimerValue(item?.data[0]?.closingDateTime);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> Check data", getDropdownData);
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const loadTechUser = async () => {
    let obj = {
      roleId: "TECHNICAL",
    };
    await ItemService.getTechnicalUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  useEffect(() => {
    loadInitialPageData();
    loadTechUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderNr]);

  // Render Questions
  const RenderInputField = ({ questionData }) => {
    const { componentId, mandatory, question, answerDefinition, serialNo } =
      questionData;

    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <TextAreaField
              label={serialNo + ". " + question?.label}
              id={componentId}
              name={componentId}
              className="inputBox"
              placeholder=""
              // value={getRemarks}
              // onChange={handleInputChange}
              required={mandatory}
            />
          </Col>
        );
      case "select":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <ComboboxField
              label={serialNo + ". " + question?.label}
              placeholder=""
              data={answerDefinition?.options}
              id={componentId}
              iconClassName="dropdownIcon"
              name={componentId}
              code={componentId}
              required={mandatory}
              // setValue={formData.type || ""}
              // getvalue={setDropdownData}
            />
          </Col>
        );
      case "radio":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              return (
                <div key={index} className="block">
                  <input
                    type="radio"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    // value={option?.value}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "checkbox":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              return (
                <div key={index} className="block">
                  <input
                    type="checkbox"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    // value={option?.value}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "text":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="text"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              // value={option.value}
              // onChange={(e) =>
              //   handleOptionChange(index, e.target.value)
              // }
              required={mandatory}
            />
          </Col>
        );
      case "number":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="number"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              // value={option.value}
              // onChange={(e) =>
              //   handleOptionChange(index, e.target.value)
              // }
              required={mandatory}
            />
          </Col>
        );
      default:
        return "";
    }
  };

  const updateTimerValue = (closingDateTime) => {
    let timerData = {};
    const openingMoment = moment(); // This is the current date-time
    const closingMoment = moment(closingDateTime, "YYYY-MM-DD HH:mm");
    const diffInMilliseconds = closingMoment.diff(openingMoment);
    const duration = moment.duration(diffInMilliseconds);

    // If the time is already past, return 0 and set timeExpired flag
    if (diffInMilliseconds <= 0) {
      setFinalTimerValue({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    } else {
      // Extract days, hours, minutes, and seconds correctly
      timerData.days = Math.floor(duration.asDays()) || 0;
      timerData.hours = duration.hours() || 0; // Remaining hours after days
      timerData.minutes = duration.minutes() || 0; // Remaining minutes after hours
      timerData.seconds = duration.seconds() || 0; // Remaining seconds after minutes
      setFinalTimerValue(timerData);
    }
  };

  const handleTextChange = (data) => {
    // console.log(">> data", data);
  };

  const [getTechOpenDisabled, setTechOpenDisabled] = useState(false);
  const handleTechOpen = async () => {
    let requiredFields = [];

    if (!validateRequired(formInputs?.rfxTechFocalPersonIdCode)) {
      requiredFields.push("*Please select the Tech Focal Point");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    let obj = {
      tenderNr: formInputs.tenderNr,
      techUserId: formInputs?.rfxTechFocalPersonIdCode,
    };
    setTechOpenDisabled(true);
    await ItemService.rfxTechOpen(obj).then((item) => {
      // console.log(">> item! ", item);
      if (item?.status === 200) {
        modalDataTeach.successMsg = item?.message;
        setModalInfo(modalDataTeach);
        onSuccessfullyRegistered();
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTechOpenDisabled(false);
  };

  const handleCommOpen = async () => {
    // let requiredFields = [];

    // if (!validateRequired(formInputs?.rfxTechFocalPersonIdCode)) {
    //   requiredFields.push("*Please select the Tech Focal Point");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    let obj = {
      tenderNr: formInputs.tenderNr,
      commUserId: "", // Add user in future
    };
    setTechOpenDisabled(false);
    await ItemService.rfxCommOpen(obj).then((item) => {
      // console.log(">> item! ", item);
      if (item?.status === 200) {
        modalDataComm.successMsg = item?.message;
        setModalInfo(modalDataComm);
        onSuccessfullyRegistered();
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTechOpenDisabled(true);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  return (
    <main className="" id="">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <Loader isLoading={loading} className={"text-center"} />
        </Col>
        {!loading && (
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                Tender Details:{" "}
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs?.tenderNr}
                </span>
                <span>
                  {formInputs?.tenderHeaderStatus === "Published" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "QTN Received" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Cancelled" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "RFQ Created" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Tech Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Technical Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Commercial Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus ===
                    "Commercial Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus ===
                    "Commercial Pending with L1" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus ===
                    "Commercial Pending with L2" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : formInputs?.tenderHeaderStatus === "Tender Created" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.tenderHeaderStatus}
                    </span>
                  ) : (
                    formInputs?.tenderHeaderStatus
                  )}
                </span>
                
              </h2>
              <Col xs={3} md={2} lg={2} className="px-1">
                <button className="btnTable w-30" onClick={navigateToLogin}>
                  <i className="bi bi-box-arrow-in-right"></i> Tender List
                </button>
              </Col>
              <p className="subText">Tender Details</p>
              <hr />

              {config?.showInDetailPage &&
                formInputs?.workflowActionLogs?.length > 0 && (
                  <ShowHorizontalStatus
                    rowdatamodal={formInputs?.workflowActionLogs}
                  />
                )}

              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={12} md={5} lg={5} className="">
                        <p className="headerTitle fs-4">
                          Remaining Time for submission
                        </p>
                      </Col>
                      <Col xs={12} md={7} lg={7} className="flex justify-end">
                        <img
                          src="assets/img/stopwatch.png"
                          alt="stopwatch"
                          style={{ width: "60px", height: "58px" }}
                          className="mr-6 mt-1"
                        />

                        <PageLevelRiverseTimer timerData={finalTimerValue} />
                      </Col>
                    </Row>
                  </h2>
                </div>
              </div>

              {/*Tender Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TT</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Tender Type</span>
                        <span className="subHeaderTitle">
                          Basic Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Tender Type"
                            placeholder=""
                            // data={getRFxType}
                            id="tenderTypeCategory"
                            iconClassName="dropdownIcon"
                            name="tenderTypeCategory"
                            code="tenderTypeCategoryCode"
                            description="tenderTypeCategoryDesc"
                            setValue={formInputs.tenderTypeCategory || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Product Type"
                            placeholder=""
                            // data={getRFxProductType}
                            id="productType"
                            iconClassName="dropdownIcon"
                            name="productType"
                            code="productTypeCode"
                            description="productTypeDesc"
                            setValue={formInputs.productTypeDesc || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Estimated Tender Value *"
                            id="tenderValue"
                            name="tenderValue"
                            placeholder=""
                            // type="checkbox"
                            value={formInputs.tenderValue || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Bid Type"
                            placeholder=""
                            // data={getRfxBidType}
                            id="tenderbidType"
                            iconClassName="dropdownIcon"
                            name="tenderbidType"
                            code="tenderbidTypeCode"
                            description="rfxbidTypeDesc"
                            setValue={formInputs.tenderbidTypeDesc || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Number Of Evaluation"
                            placeholder=""
                            // data={getRfxNoOfEvaluationType}
                            id="tenderEvalType"
                            iconClassName="dropdownIcon"
                            name="tenderEvalType"
                            code="tenderEvalTypeCode"
                            description="tenderEvalTypeDesc"
                            setValue={formInputs.tenderEvalTypeDesc || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Currency"
                            placeholder=""
                            // data={getcurrency}
                            id="tenderCurrency"
                            iconClassName="dropdownIcon"
                            name="tenderCurrency"
                            code="tenderCurrencyCode"
                            description="tenderCurrencyDesc"
                            setValue={formInputs.tenderCurrency || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Tech Focal Point"
                            placeholder=""
                            data={getTechnicalUserList}
                            id="tndFocalTechPid"
                            iconClassName="dropdownIcon"
                            name="tndFocalTechPid"
                            code="tndFocalTechPidCode"
                            description="tndFocalTechPidDesc"
                            setValue={formInputs.tndFocalTechPid || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Technical Approval Type"
                            placeholder=""
                            // data={getTechnicalApprovalType}
                            id="technicalApprovalType"
                            iconClassName="dropdownIcon"
                            name="technicalApprovalType"
                            code="technicalApprovalTypeCode"
                            description="technicalApprovalTypeDesc"
                            setValue={
                              formInputs.technicalApprovalTypeDesc || ""
                            }
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* 02  Tender Heder*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TH</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Tender Header</span>
                        <span className="subHeaderTitle">
                          Tender Description
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tender Responsible"
                            name="tenderResponsible"
                            placeholder=""
                            value={formInputs.tenderResponsible || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Create / Initiator"
                            name="initiator"
                            placeholder=""
                            value={formInputs.initiator || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Plant"
                            placeholder=""
                            // data={getPlant}
                            id="plant"
                            iconClassName="dropdownIcon"
                            name="plant"
                            code="plantCode"
                            description="plantDesc"
                            setValue={formInputs.plant || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Company Address"
                            placeholder=""
                            // data={getCompanyAddress}
                            id="companyAddress"
                            iconClassName="dropdownIcon"
                            name="companyAddress"
                            code="companyAddressCode"
                            description="companyAddressDesc"
                            setValue={formInputs.companyAddress || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tender Version"
                            name="tenderVersion"
                            id="tenderVersion"
                            placeholder=""
                            value={formInputs.tenderVersion || ""}
                            onChange={onInputChange}
                            // disabled={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Email"
                            name="buyerEmail"
                            id="buyerEmail"
                            placeholder=""
                            value={formInputs.buyerEmail || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Billing Address"
                            placeholder=""
                            // data={getBillingAddress}
                            id="billingAddress"
                            iconClassName="dropdownIcon"
                            name="billingAddress"
                            code="billingAddressCode"
                            description="billingAddressDesc"
                            setValue={formInputs.billingAddress || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created On"
                            name="createdOn"
                            id="createdOn"
                            placeholder=""
                            value={formInputs.createdOn || ""}
                            onChange={onInputChange}
                            // disabled={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tender Contact"
                            name="tenderContact"
                            id="tenderContact"
                            placeholder=""
                            value={formInputs.tenderContact || ""}
                            onChange={onInputChange}
                            // disabled={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Delivery Address"
                            placeholder=""
                            // data={getDeliveryAddress}
                            id="deliveryAddressCodeDesc"
                            iconClassName="dropdownIcon"
                            name="deliveryAddressCodeDesc"
                            setValue={formInputs.deliveryAddressCodeDesc || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Tender Category"
                            name="tenderTypeCategory"
                            id="tenderTypeCategory"
                            placeholder=""
                            value={formInputs.tenderTypeCategory}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* header info 03*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Tender Info</span>
                        <span className="subHeaderTitle">
                          Tender Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="tenderTitle"
                            id="tenderTitle"
                            placeholder=""
                            value={formInputs.tenderTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Opening Date"
                            name="openingDate"
                            id="openingDate"
                            type="date"
                            placeholder=""
                            value={formInputs.openingDate || ""}
                            // onChange={onInputChangeopeningDate}
                            required={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Opening Time"
                            name="openingTime"
                            id="openingTime"
                            type="time"
                            placeholder=""
                            value={formInputs.openingTime || ""}
                            // onChange={onInputChangeopeningDate}
                            required={true}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="tenderDescription"
                            id="tenderDescription"
                            placeholder=""
                            value={formInputs.tenderDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Closing Date"
                            name="closingDate"
                            id="closingDate"
                            type="date"
                            placeholder=""
                            value={formInputs.closingDate || ""}
                            // onChange={onInputChangeopeningDate}
                            required={true}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Closing Time"
                            name="closingTime"
                            id="closingTime"
                            type="time"
                            placeholder=""
                            value={formInputs.closingTime || ""}
                            // onChange={onInputChangeopeningDate}
                            required={true}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Type of Tender"
                            placeholder=""
                            // data={getRfxPurchaseType}
                            id="tenderType"
                            iconClassName="dropdownIcon"
                            name="tenderType"
                            setValue={formInputs.tenderType || ""}
                            getvalue={setDropdownData}
                            disabled={true}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <MultiselectField
                            label="Other Currencies"
                            placeholder="Please select the Other Currencies"
                            // data={getcurrency}
                            id="othercurrencies"
                            iconClassName="dropdownIcon"
                            name="othercurrencies"
                            // getvalue={setDropdownData}
                            value={formInputs.othercurrencies}
                            className="dropdownOption"
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Payment Term"
                            placeholder=""
                            // data={getpaymentTerm}
                            id="otherCurrencies"
                            iconClassName="dropdownIcon"
                            name="otherCurrencies"
                            setValue={formInputs.otherCurrencies || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <MultiselectField
                            label="INCO Terms"
                            placeholder="Please select the INCO Terms"
                            // data={getINCOTerms}
                            id="INCOTerms"
                            iconClassName="dropdownIcon"
                            name="INCOTerms"
                            getvalue={setDropdownData}
                            className="dropdownOption"
                            disabled={true}
                            // value={formInputs.INCOTerms || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCO Terms Location"
                            name="incoTermsLocation"
                            id="incoTermsLocation"
                            placeholder=""
                            // setValue={formInputs.incoTermsLocation || ""}
                            value={formInputs.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Reminder Enabled"
                            placeholder=""
                            // data={reminderDropDown}
                            id="reminderEnabled"
                            iconClassName="dropdownIcon"
                            name="reminderEnabled"
                            setValue={formInputs.reminderEnabled || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <FileUploadComponent
                            id="instructionsAttachment"
                            name="instructionsAttachment"
                            label="Instructions Attachment"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            // onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.instructionsAttachment || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          {(formInputs?.instructionsAttachment && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(
                                  formInputs?.instructionsAttachment
                                )
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Instructions 10*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible10
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RE</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Instructions</span>
                        <span className="subHeaderTitle">
                          Instructions Section
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible10 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="p-4">
                        <Col xs={12} md={12} lg={12}>
                          {formInputs?.instructions && (
                            <RichTextEditor
                              value={formInputs?.instructions}
                              readOnly={true}
                              onChange={handleTextChange}
                            />
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Documents */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible4
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Documents</span>
                        <span className="subHeaderTitle">Documents Form</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible4 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <h5 className="card-title"> Terms & Conditions</h5>
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={12}
                          lg={8}
                          className="commTopButtonRightLeftPadding"
                        >
                          {formInputs?.termsConditions?.map((item, i) => (
                            <div className="form-check" key={item.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`gridCheck${item.id}`}
                                checked={item.status}
                                disabled={true}
                                // onChange={() =>
                                //   handleTermsConditionCheckBox(item.id)
                                // }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`gridCheck${item.id}`}
                              >
                                {item.name}
                              </label>
                            </div>
                          ))}
                        </Col>
                        <Row>
                          <h1 className="card-title">Documents :</h1>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.1. SCOPE OF WORK</p>
                            {(formInputs?.scopeOfwork && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.scopeOfwork)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.2. DRAWING</p>
                            {(formInputs?.drawing && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.drawing)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.3. ANNEXURES</p>
                            {(formInputs?.annexures && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.annexures)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.4. OTHERS</p>
                            {(formInputs?.others && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.others)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* 6 Line Items*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible6
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility6}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Line Items</span>
                        <span className="subHeaderTitle">
                          Material/ Service Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible6 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={PRLineItemInitialCol}
                            data={data}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // pagination={false}
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* COMM - Spares & Operation Maintenance 08*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible8
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form: COMMERCIAL - Questionnaire
                        </span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible8 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {formInputs?.formCOMM?.length > 0 &&
                          formInputs?.formCOMM.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                key={index}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Form :TECH - Spares & Operation Maintenance09*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible9
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility9}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TS</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form : TECHNICAL - Questionnaire
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible9 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {formInputs?.formTECH?.length > 0 &&
                          formInputs?.formTECH.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                key={index}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Single Source Justification*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible8
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SS</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Single Source Justification
                        </span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>

                      <Col xs={1} md={1} lg={1} className="">
                        {/* <SourcingCommonFilter /> */}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible8 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      {/* Form: INTRO-Spares & Operations Maintenance */}
                      <Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Single Source Justification"
                            name=""
                            // placeholder=""
                            // value={PriceSheduleModuledata.UnitPrice || ""}
                            onChange={onInputChange}
                            // disabled={getInputFields}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pageFooter">
                <Row className="rowDirection">
                  {sourcingConfig?.RFX?.pageBtn?.preClose &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "QTN Received") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          Pre Close
                        </button>
                      </Col>
                    )}

                  {sourcingConfig?.RFX?.pageBtn?.rFQCancel &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "Technical Open") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          RFQ Cancel
                        </button>
                      </Col>
                    )}

                  {sourcingConfig?.RFX?.pageBtn?.techOpen &&
                    formInputs?.rfxHeaderStatus === "QTN Received" && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          onClick={handleTechOpen}
                          disabled={getTechOpenDisabled}
                        >
                          Tech Open
                        </button>
                      </Col>
                    )}

                  {sourcingConfig?.RFX?.pageBtn?.commOpen &&
                    (formInputs?.rfxHeaderStatus === "QTN Received" ||
                      formInputs?.rfxHeaderStatus === "Tech Approved") && (
                      <Col xs={12} md={2} lg={2} className="">
                        <button className="btnTable" onClick={handleCommOpen}>
                          Comm Open
                        </button>
                      </Col>
                    )}

                  {sourcingConfig?.RFX?.pageBtn?.rFQModify &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "QTN Received" ||
                      formInputs?.rfxHeaderStatus === "Tech Approved" ||
                      formInputs?.rfxHeaderStatus === "Technical Open") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          RFQ Modify
                        </button>
                      </Col>
                    )}

                  {sourcingConfig?.RFX?.pageBtn?.excelDownload && (
                    <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        //  onClick={handleModify}
                      >
                        Excel Download
                      </button>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Col>
        )}
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default PublicTenderDetails;
